import * as Sentry from "@sentry/react"

// Deliberately lean: the game runs on low-end Android tablets, where the
// profiling and session-replay integrations (rrweb records every DOM
// mutation, including each animation frame) caused visible input lag.
// Errors are still reported in full; only 10% of sessions carry tracing.
Sentry.init({
  dsn: "https://6ca23ad4b0cadb7b41a43b50339504b5@o364627.ingest.us.sentry.io/4508055174709248",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/my-choices.thirdeyetech.io/],
})
